import { Box, Flex, Text } from '@chakra-ui/react';
import { useGameColorsProvider } from '../../../providers/Theme/gameColorsProvider';

export const SpecificBodyInfo = ({ text, value }: { text: string; value: any }) => {
	const { textColor } = useGameColorsProvider();

	return (
		<Flex zIndex="0">
			<Text
				color={`${textColor}80`}
				userSelect="none"
			>
				{text}&nbsp;
			</Text>
			<Box fontWeight="600">{value}</Box>
		</Flex>
	);
};
